import { memo } from "react";

import IacManagementEmptyCellValue from "../../components/CellEmptyValue";
import { RenderGroupRowCellProps } from ".";
import IacManagementGroupCell from "../components/GroupCell";

const IacManagementTableGroupRowCellResourceAddress = memo((props: RenderGroupRowCellProps) => {
  return (
    <IacManagementGroupCell {...props}>
      <IacManagementEmptyCellValue />
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellResourceAddress.displayName =
  "IacManagementTableGroupRowCellResourceAddress";

export default IacManagementTableGroupRowCellResourceAddress;
